export default {
  'reports.title': 'Gestionar Reportes',
  'reports.reportGroups': 'Grupo de Reportes',
  'reports.form.reportGroup': 'Grupo de Reportes',
  'reports.form.reportId': 'Id Reporte PowerBI',
  'reports.form.datasetId': 'Id Dataset PowerBI',
  'reports.form.defaultReportSection': 'Sección del Reporte Predeterminada',
  'reports.form.isMultipage': '¿Múltiples Páginas?',
  'reports.form.isReportDataFilterByUserEnabled': '¿Filtro de Datos por Usuario?',
  'reports.form.isReportDataFilterByPositionEnabled': '¿Filtro de Datos por Puesto?',
  'reports.form.reportDataFilterUserTableName': 'Nombre de tabla para filtro por usuario',
  'reports.form.reportDataFilterUserFieldName': 'Nombre de campo para filtro por usuario',
  'reports.form.reportDataFilterUserFieldNameInternal':
    'Nombre interno de campo para filtro por usuario',
  'reports.form.reportDataFilterPositionTableName': 'Nombre de tabla para filtro por puesto',
  'reports.form.reportDataFilterPositionFieldName': 'Nombre de campo para filtro por puesto',
  'reports.form.reportDataFilterPositionFieldNameInternal':
    'Nombre interno de campo para filtro por puesto',
  'reports.form.isReportDataFilterByAreaEnabled': '¿Filtro de Datos por Área?',
  'reports.form.reportDataFilterAreaTableName': 'Nombre de tabla para filtro por área',
  'reports.form.reportDataFilterAreaFieldName': 'Nombre de campo para filtro por área',
  'reports.form.reportDataFilterAreaFieldNameInternal':
    'Nombre interno de campo para filtro por área',
  'reports.form.isReportDataFilterByDynamicEntityEnabled': '¿Filtro de Datos por Entidad Dinámica?',
  'reports.form.reportDataFilterDynamicEntityTableName':
    'Nombre de tabla para filtro por entidad dinámica',
  'reports.form.reportDataFilterDynamicEntityFieldName':
    'Nombre de campo para filtro por entidad dinámica',
  'reports.form.reportDataFilterDynamicEntityId': 'Entidad Dinámica',
  'reports.form.reportDataFilterDynamicEntityFieldUserFieldId': 'Entidad Dinámica / Campo Usuario',
  'reports.form.reportDataFilterDynamicEntityFieldDataFieldId': 'Entidad Dinámica / Campo Filtro',
  'reports.form.isReportDataFilterByUserGroupsEnabled': '¿Filtro de Datos por Grupo de Usuarios?',
  'reports.form.reportDataFilterUserGroupTableName':
    'Nombre de tabla para filtro por grupo de usuarios',
  'reports.form.reportDataFilterUserGroupFieldName':
    'Nombre de campo para filtro por grupo de usuarios',
  'reports.form.reportDataFilterUserGroupFieldNameInternal':
    'Nombre interno de campo para filtro por grupo de usuarios',
  'reports.type.administration': 'Administración',
  'reports.type.process': 'Proceso',
  'reports.type.request': 'Solicitud',
  'reports.type.generic': 'Genérico',
  'reports.platform.web': 'Web',
  'reports.platform.mobile': 'Móvil',
  'reports.platform.webMobile': 'Web y Móvil',
  'reports.logicalOperator.or': 'OR',
  'reports.logicalOperator.and': 'AND',
  'reports.permissionsFiltersLogicalOperator': 'Operador Lógico Permisos',
};
